import filter from 'lodash.filter'
import find from 'lodash.find'

// initial state
const state = {
  banners: [
    {
      id: 'HELLOTREDZ',
      tagline: 'Tredz Customers - Book now to get our Deluxe Service with a £20 discount! Your bike will look and ride like new!',
      image: 'https://d2w46cz0afxd34.cloudfront.net/assets/banners/tredz-havebike-banner.jpg',
      width: '870px',
      start_date: 1637236800, // Thu Nov 18 2021 12:00:00 GMT+0000
      end_date: 3638287782 // Mon Apr 16 2085 19:29:42 GMT+0000
    }
  ],
  promoToShow: null
}

// getters
const getters = {
  /* Return an array of all active promotions */
  activeBanners (state) {
    return filter(state.banners, (banner) => {
      return bannerIsActive(state, banner)
    }) || []
  },

  /* Check the validity of the promotion */
  promoIsActive: (state) => (id) => {
    return typeof find(state.banners, (banner) => {
      return (banner.id === id) && bannerIsActive(state, banner)
    }) !== 'undefined'
  }
}

const mutations = {
  setPromoToShow (state, id) {
    state.promoToShow = id
  }
}

function bannerIsActive (state, banner) {
  return banner.start_date && banner.end_date && (Date.now() > (banner.start_date * 1000)) && ((banner.end_date * 1000) > Date.now()) && (typeof banner.show_when === 'undefined' || (banner.show_when !== 'undefined' && banner.show_when.includes(state.promoToShow))) && !(typeof banner.hide_when !== 'undefined' && banner.hide_when.includes(state.promoToShow))
}

export default {
  state,
  getters,
  mutations
}
